const sortByRegExp = (array, regex) => {
  return array.sort(function (a, b) {
    const aMatch = a.match(regex) || [];
    const bMatch = b.match(regex) || [];
    return bMatch.length - aMatch.length;
  });
};
export { sortByRegExp };